import { ReactNode } from "react";
import { Crosshair, ListTree, Network } from "lucide-react";
import { PageHeaderFrame } from "@/components/layout/page-header-frame";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export type OkrView = "objectives" | "coverage";

interface OkrPageHeaderProps {
  totalObjectives: number;
  view: OkrView;
  onViewChange: (view: OkrView) => void;
  right?: ReactNode;
}

/** OKRs page identity block + the Objectives/Coverage view toggle. */
export function OkrPageHeader({ totalObjectives, view, onViewChange, right }: OkrPageHeaderProps) {
  return (
    <PageHeaderFrame
      icon={Crosshair}
      title="OKRs"
      description={
        totalObjectives > 0 ? (
          <>Tracking <span className="font-medium text-foreground">{totalObjectives}</span> company objectives</>
        ) : (
          "Company objectives, key results and the PPPs that deliver them"
        )
      }
      right={right}
    >
      <div className="flex w-fit rounded-md border bg-background/60">
        <Button
          variant={view === "objectives" ? "default" : "ghost"}
          size="sm"
          className={cn("gap-1.5 rounded-r-none border-0", view !== "objectives" && "text-muted-foreground")}
          onClick={() => onViewChange("objectives")}
        >
          <ListTree className="h-3.5 w-3.5" /> Objectives
        </Button>
        <Button
          variant={view === "coverage" ? "default" : "ghost"}
          size="sm"
          className={cn("gap-1.5 rounded-l-none border-0", view !== "coverage" && "text-muted-foreground")}
          onClick={() => onViewChange("coverage")}
        >
          <Network className="h-3.5 w-3.5" /> Coverage
        </Button>
      </div>
    </PageHeaderFrame>
  );
}
